import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { Observable, of, throwError } from "rxjs";
import { delay, mergeMap, materialize, dematerialize } from "rxjs/operators";
import { User } from "../models/user";

const users: User[] = [
  {
    id: 1,
    img: "assets/images/user/admin.jpg",
    username: "1001",
    password: "86sa",
    firstName: "Sarah",
    lastName: "Smith",
    token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyaWQiOiI4NiIsInNvY2lkIjoiMSIsInN0cmluZ0NvbiI6IlBlcnNpc3QgU2VjdXJpdHkgSW5mbyA9IEZhbHNlOyBVc2VyIElEID1zYTsgUGFzc3dvcmQgPXZuZXh0JCQkMTIzOyBJbml0aWFsIENhdGFsb2cgPSBJUVVSQTsgU2VydmVyID1WTkVYVC1TT0ZUMVxcVk5FWFRTT0ZUIiwicm9sZSI6IlRydWUiLCJjb25zdHIiOiJOSXJWZ1Vvc1JQU2ZLcjUyZ2V4ZjBReWFHTHFSelBFUzd2cXZlaEQzYzBITnZxWXFDakltdFhNYTBPcGF2elVmeHZoRzJNVU5ObkNNRk1tRUl3U1M0enJSdWpzbzNGdHN1TVY3QU9QY25RTHZOSmEvWkNjOVRvWCtDTkJBRlNLSHMxVEkyTjRFZFMyQ0xZRnI1aGI5R2RSMjg1N09kajlOMkNZWFZVUkM0c0U9IiwiZXhwIjoxNzA4NTE4MzcxLCJpc3MiOiJodHRwOi8vd3d3LmJyaWdodC1jYW1wdXMuY29tIiwiYXVkIjoiaHR0cDovL3d3dy5icmlnaHQtY2FtcHVzLmNvbSJ9.aLFAB8DUgw2ZhcwseDlf6u10cCMKFiE9fSzJI63UBk0",
  },
];

@Injectable()
export class FakeBackendInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const { url, method, headers, body } = request;
    // wrap in delayed observable to simulate server api call
    return of(null).pipe(mergeMap(handleRoute));

    function handleRoute() {
      switch (true) {
        case url.endsWith("/authenticate") && method === "POST":
          return authenticate();
        default:
          // pass through any requests not handled above
          return next.handle(request);
      }
    }

    // route functions

    function authenticate() {
      const { username, password } = body;
      const user = users.find(
        (x) => x.username === username && x.password === password
      );
      if (!user) {
        return error("Username or password is incorrect");
      }
      return ok({
        id: user.id,
        img: user.img,
        username: user.username,
        firstName: user.firstName,
        lastName: user.lastName,
        token: user.token,
      });
    }

    // helper functions

    function ok(body?) {
      return of(new HttpResponse({ status: 200, body }));
    }

    function error(message) {
      return throwError({ error: { message } });
    }

    function unauthorized() {
      return throwError({ status: 401, error: { message: "Unauthorised" } });
    }

    function isLoggedIn() {
      return headers.get("Authorization") === "Bearer fake-jwt-token";
    }
  }
}

export let fakeBackendProvider = {
  // use fake backend in place of Http service for backend-less development
  provide: HTTP_INTERCEPTORS,
  useClass: FakeBackendInterceptor,
  multi: true,
};
